import * as e from "@amplitude/analytics-browser";
import t from "platform";
import { MemoryStorage as n } from "@amplitude/analytics-core";
import { Experiment as r } from "@amplitude/experiment-js-client";
import { createContext as i, useContext as a, useEffect as o, useMemo as s } from "react";
import { jsx as c } from "react/jsx-runtime";
//#region src/config.ts
var l = () => ({
	platform_os: t.os?.toString() ?? "unknown",
	platform_name: t.name ?? "unknown",
	platform_osVersion: t.version ?? "unknown",
	platform_product: t.product ?? "unknown",
	platform_manufacturer: t.manufacturer ?? "unknown",
	platform_layout: t.layout ?? "unknown",
	platform_description: t.description ?? "unknown"
}), u = () => "a09fe4add8580a204c36b1a34931cfdb", d = () => "client-I2mWf7HDaIlT8yL7qRWZAQ5kd4eZc3Gh", f = {
	disableExitSurvey: "disable-exit-survey",
	askForFeedbackOnResult: "ask-for-feedback-on-result",
	emailCollectionFeedback: "email-collector-feedback",
	promoteAssisted: "promote-assisted"
}, p = {
	control: "control",
	treatment: "treatment",
	variantA: "variant-a",
	variantB: "variant-b"
}, m = 500, h = /* @__PURE__ */ function(e) {
	return e.OpenSidebar = "visa open sidebar", e.CloseSidebar = "visa close sidebar", e.ShowQrCode = "visa show qr code", e.SignInStart = "visa show sign in", e.InputEmail = "visa input email", e.VerifiedEmail = "visa verified email", e.ShowScanList = "visa show scan list", e.SelectScan = "visa select scan", e.ClaimedScan = "visa claimed scan", e.OpenStoreFinder = "visa open store finder", e.ShowRecommendation = "visa show recommendation", e.ShowError = "visa show error", e.MeshViewInteraction = "visa user interact with mesh view", e.Feedback = "visa leave feedback", e.EmailCollectorWithGift = "visa leave email with gift", e.ShowFeedbackModal = "visa show feedbackModal", e.StartOverBT = "visa user tap on start over button", e.ShowRecommendationEducation = "visa show recommendation education", e.MoreInfoRecommendationEducation = "visa show more info link recommendation education", e.OpenPrivacyPolicy = "visa open privacy policy link", e.Checkout = "visa checkout", e.ExitScanning = "visa exit scanning", e.AgeRestriction = "visa age restriction modal", e.ContinueShopping = "visa tap continue shopping", e.NextResultEducationModal = "visa show next result education modal", e.ResultEducationModal = "visa tap show result education modal", e.CloseResultEducationModal = "visa close result education modal", e.CloseSizeChart = "visa user tap close size chart", e.FailLoadSizeChart = "visa failed to load size chart", e.ExitWithoutRecommendation = "visa user tap on exit without recommendation", e.GoToScannerFromSizeChart = "visa user tap on load scanner button", e.ContinueFromIntro = "visa user tap on continue on intro page", e.SizeChartNPS = "visa user rate size chart", e.SizeChartComment = "visa user submit comment on size chart", e.GetHelpPromptShown = "visa show get help prompt", e.GetHelpPromptSelect = "visa get help prompt select", e.OnboardingCompleted = "web scanner complete onboarding", e.ValidationFailure = "web scanner fail validation", e.ReconstructionFailure = "web scanner fail reconstruction", e.ReconstructionStarted = "web scanner start reconstruction", e.ReconstructionSuccess = "web scanner succeed reconstruction", e.BackToIntro = "web scanner back to intro", e.BackToPicker = "web scanner back to picker", e.IntroLoadSolo = "web scanner load Solo on continue from Intro", e.PickerLoadNormal = "web scanner press scan my self", e.PickerLoadAssisted = "web scanner press assisted scanning", e.UserLeftWebpage = "web scanner leave page", e.UserTappedTryAgain = "web scanner try again", e.Capture1 = "web scanner capture stage1 complete", e.Capture2 = "web scanner capture stage2 complete", e.CaptureShot = "web scanner capture shot", e.PaperTypeChange = "web scanner user changed paper type", e.PaperSelected = "web scanner select paper size", e.CameraLoadingError = "web scanner failed to load camera", e.CameraPhotoError = "web scanner failed to take photo", e.AddBrandToSurvey = "web scanner add brand to fit survey", e.AddSizeToSurvey = "web scanner add size to fit survey", e.AddWidthToSurvey = "web scanner add width to fit survey", e.AddGenderToSurvey = "web scanner add gender age to fit survey", e.SubmitSurvey = "web scanner submit fit survey", e.SurveyRecommendationFailure = "web scanner failed fit survey recommendation", e.SurveyRecommendationStarted = "web scanner started fit survey recommendation", e.SurveyOnboardingCompleted = "web scanner complete onboarding fit survey", e.HybridSurvey = "web scanner show hybrid survey", e.ScannerIntro = "web scanner show hybrid scanning intro", e.SkipToResultHybrid = "web scanner user tap skip to result", e.HybridLeaveOnScannerIntro = "web scanner user tap close on scanning intro page", e.SkipFitSurvey = "web scanner user tap on skip fit survey in hybrid flow", e.SizeChartScroll = "web scanner user scroll size chart", e.SizeChartChangeLocale = "web scanner change size chart locale", e.SocksQuestion = "web scanner user response to socks question", e.OnboardingScannerDetail = "web scanner show onboarding scanner detail", e.RedirectToScanner = "web scanner redirect to standalone scanner", e.ScannerCallbackResult = "web scanner complete standalone scanner", e.ScannerCallbackAbort = "web scanner abort standalone scanner", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.Environment = "environment", e.TenantToken = "tenant_token", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.SkipAndLeave = "skip and leave", e.Close = "close", e;
}({}), v = class {
	track = (t, n) => {
		let r = {
			...n ? { ...n } : {},
			...l()
		};
		e.track(t, r);
	};
	trackAndFlush = async (t, n, r = m) => {
		let i = {
			...n ? { ...n } : {},
			...l()
		};
		try {
			let n = e.track(t, i), a = async () => (await n.promise, await e.flush().promise, !0), o = new Promise((e) => {
				setTimeout(() => e(!1), r);
			});
			if (!await Promise.race([a(), o])) throw Error("Analytics flush timed out");
		} catch {}
	};
	trackerUserId = () => e.getUserId();
	trackerDeviceId = () => e.getDeviceId();
}, y = i(void 0);
//#endregion
//#region src/analytics-provider.tsx
function b() {
	let e = "volumentalTest";
	try {
		return localStorage.setItem(e, e), localStorage.removeItem(e), !0;
	} catch {
		return !1;
	}
}
var x = async (e) => {
	await e.fetch();
}, S = (t, n) => {
	let r = new e.Identify();
	r.set(t, n), e.identify(r);
}, C = () => {
	e.setTransport("beacon"), e.flush();
}, w = ({ amplitudeApiKey: t, experimentKey: i, debugMode: a = !1, disabled: l = !1, deviceId: u, optOut: d, children: f }) => {
	if (l) return s(() => /* @__PURE__ */ c(y.Provider, {
		value: {
			isVariantActive: () => !1,
			getVariantPayload: () => void 0,
			getAllExperiments: () => ({}),
			setUserProperty: () => void 0,
			getSessionId: () => void 0,
			getDeviceId: () => void 0,
			optOutUser: () => void 0
		},
		children: f
	}), [f]);
	let p = s(() => {
		let o = b();
		if (e.getSessionId() === void 0 && e.init(t, {
			instanceName: "volumental",
			deviceId: u,
			identityStorage: o ? "localStorage" : "none",
			storageProvider: o ? void 0 : new n(),
			defaultTracking: {
				attribution: !0,
				fileDownloads: !1,
				formInteractions: !1,
				pageViews: !1,
				sessions: !0
			},
			optOut: d
		}), S(g.Environment, "production"), o) {
			let e = r.initializeWithAmplitudeAnalytics(i, {
				debug: a,
				instanceName: "volumental"
			});
			return x(e), e;
		}
		return {
			variant: () => ({}),
			all: () => ({})
		};
	}, [
		a,
		t,
		i
	]), m = s(() => ({
		isVariantActive: (e, t = "on") => p.variant(e).value === t,
		getVariantPayload: (e) => p.variant(e).payload,
		getAllExperiments: () => p.all(),
		setUserProperty: S,
		getSessionId: e.getSessionId,
		getDeviceId: e.getDeviceId,
		optOutUser: e.setOptOut
	}), [p]);
	return o(() => (window.addEventListener("unload", C), () => {
		window.removeEventListener("unload", C);
	}), []), s(() => /* @__PURE__ */ c(y.Provider, {
		value: m,
		children: f
	}), [f, m]);
}, T = () => {
	let e = a(y);
	if (!e) throw Error("useAnalytics must be used within an AnalyticsProvider");
	return e;
}, E = new v();
//#endregion
export { w as AnalyticsProvider, _ as ExitReason, d as GetExperimentKey, u as GetTrackingKey, h as UsageTrackerEvent, g as UserProperty, f as VariantFlag, p as Variants, E as usageTracker, T as useAnalytics };
